import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';
import numeral from 'numeral';

import BaseViewStore from 'base-viewstore';

export class ProgressBarViewStore extends BaseViewStore {

    @observable value = 0;

    constructor(props) {
        super(props);

        if(this.props.form) {
            this.props.form.controls.push(this);
        }

        this.update();
    }

    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        return invalid;
    }  

    @action.bound save() {
    }
    
    @action.bound update() {
        
        let val = this.props.contentModel.value;
        if(this.props.form && this.props.contentModel.variable && (typeof (this.props.form.dbVariableStore[this.props.contentModel.variable])) !== 'undefined') {
            val = this.props.form.dbVariableStore[this.props.contentModel.variable];
        }

        try {
            val = numeral(val).value();
            if(isNaN(val)) {
                val = 0;
            }
            else if(val < 0) {
                val = 0;
            }
            else if(val > 1) {
                val = val / 100;
            }

        }
        catch(e) {
            val = 0;
        }
        if(val > 1) {
            val = 1;
        }
        this.value = val;
    }
}



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/progress/viewstore.js